import { Injectable } from '@angular/core';
import {
  LoginAuthWithCredentials,
  LoginOAuth,
  SwapAuthForAccessTokens
} from '../../models';
import { UtilMethodsService } from './util-methods.service';

@Injectable({
  providedIn: 'root'
})
export class UtilServiceHelperSupportExtendedService {
  constructor(protected utilMethodsService: UtilMethodsService) {}

  isAuthErrorResponse(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    const isAuthError = !!(authResponse?.errors || authResponse?.error);
    const isAuthDetailUserMessage: boolean =
      this.utilMethodsService.isPingErrorDetailMessage(authResponse);
    const isAuthDetailCode =
      this.utilMethodsService.getAuthResponseErrorDetailsCode(authResponse);
    const isAuthErrorCode = !!authResponse?.error?.code;
    const isResourceNotFound =
      this.utilMethodsService.checkForResourceNotFoundError(authResponse);

    return this.utilMethodsService.isAuthErrorResponseHelper(
      isAuthError,
      isAuthDetailUserMessage,
      isAuthDetailCode,
      isAuthErrorCode,
      authResponse.code,
      isResourceNotFound
    );
  }
}
